export default class extends Controller {
  static targets = ['fieldSet'];

  connect() {
    this.showSelectedFieldSet();
  }

  showSelectedFieldSet() {
    this.fieldSetTargets.forEach(f => {
      const isSelectedValue = f.dataset.fieldSetName === this.selectedValue;
      App.Helpers[`${isSelectedValue ? 'show' : 'hide'}Element`](f);
      App.Form[`${isSelectedValue ? 'enable' : 'disable'}Fields`](f);
    });
  }

  //
  // GETTERS AND SETTERS
  //

  get selectedValue() {
    throw "selectedValue getter not set on extending controller";
  }
};



// WEBPACK FOOTER //
// ./app/components/forms/fields/assets/javascript/selectable-fields-controller.js